import axios from "axios";

export const CalculatorAppID = 'FlexGuardCalculatorTool';

export const defaultApiInstance = axios.create({
  timeout: 60000,
  headers: {'X-PruAppID': CalculatorAppID }
});

export const calculatorApiInstance = axios.create({
  timeout: 15000,
  headers: {'X-PruAppID': CalculatorAppID }
});
